export default __webpack_public_path__ + "static/media/loaded-bot.9eed866b.gif";